import { create } from "zustand";
import type {
  CcLandingConfig,
  Systems,
  environments
} from "@dealer-center/core-enviroment";
import {
  deriveEnvironmentName,
  deriveSystemName,
  getEnviromentConfig
} from "@dealer-center/core-enviroment";

export interface SystemEntity {
  enviroment: environments;
  system: Systems;
  config: CcLandingConfig;
}

export const useSystemStore = create<SystemEntity>()(() => ({
  enviroment: deriveEnvironmentName(window.location.href),
  system: deriveSystemName(window.location.href),
  config: getEnviromentConfig(window.location.href) as CcLandingConfig
}));
